import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M13.1137401,17.5637604 C12.4986384,18.1454132 11.5013616,18.1454132 10.8862599,17.5637604 L3.46132624,10.5425905 C2.84622459,9.96093778 2.84622459,9.01789233 3.46132624,8.43623957 C4.07642788,7.85458681 5.0737047,7.85458681 5.68880635,8.43623957 L12,14.404234 L18.3111937,8.43623957 C18.9262953,7.85458681 19.9235721,7.85458681 20.5386738,8.43623957 C21.1537754,9.01789233 21.1537754,9.96093778 20.5386738,10.5425905 L13.1137401,17.5637604 Z"
      transform="translate(0 -1)"
      fill={fill}
    />
  </g>
);

export default Icon;
